// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"212":"88293330e141c0b6b513","340":"1b0eba6b031011dbf599","563":"cbdf813d32d0d3760ef4","689":"2a39e91ec11e990f9cd3","982":"f6b2fbfb2b110966de49"}[chunkId] + ".js";
};